
export enum LogicalOperator {
    And = 0,
    Or  = 1,
    None  = 2
  }
  